import { VisitorGroup } from 'graphql/generated/graphqlTypes';
import { visitorsGroupsMembersVar } from 'state/vars';

export const setVisitorGroupsMembersAction = (groups: VisitorGroup[]) => {
  visitorsGroupsMembersVar(groups);
};
